// extracted by mini-css-extract-plugin
export default {"container":"SsoError-module__container--dIMZz"};